<style lang="sass" scoped>
.avatar-uploader
  width: 100px
  height: 100px
  border: 1px dashed #d9d9d9
  border-radius: 6px
  cursor: pointer
  position: relative
  overflow: hidden
.avatar-uploader:hover
  border-color: #20a0ff
.avatar-uploader-icon
  font-size: 22px
  color: #8c939d
  width: 100px
  height: 100px
  line-height: 100px
  text-align: center
.avatar
  width: 100px
  height: 100px
  display: block
.radio-group
  vertical-align: middle
.select
  width: 140px
.info
  margin-left: 5px
  color: #20a0ff
.el-icon-information
  position: absolute
  color: #7f8a97
  top: 10px
  right: -20px
.platform-item
  margin-left: 80px
.list-group
  line-height: 1.5em
  &.content-description
    font-size: 13px
    color: #576576
    margin-left: 100px
    margin-bottom: 15px
  &.instruction
    margin-top: 30px
    margin-left: 22px
    width: 85%
    line-height: 1.5em
    padding: 15px
    background-color: #f5f5f5
    border: 1px solid #bfcbd9
    border-radius: 3px
    li:first-child span
      color: #e02626
.add-signature-outer
  display: inline-block
  position: absolute
  top: 0
  .add-signature
    font-size: 20px
    color: #20a0ff
    &:hover
      cursor: pointer
      color: #087fd8
.del-signature
  float: right
  line-height: 1.5em
  &:hover
    color: #ff4949
.preview
  background-image: url('../assets/phone.png')
  width: 248px
  height: 474px
  p
    display: inline-block
    position: relative
    width: 204px
    top: 74px
    left: 22px
    padding: 8px 8px 8px 12px
    word-break: break-all
    font-size: 12px
    line-height: 1.3em
    background-color: #EBEFF1
    border-radius: 9px
    .sign-top
      display: block
      padding-bottom: 5px
    .sign-bottom
      display: block
      padding-top: 2px
.footer
  margin-top: 20px
  border-top: 1px solid #bfcbd9
.signature-dialog
  .footer
    border-top: none
</style>
<style lang="sass">
.is-active .el-radio-button__orig-radio:disabled+.el-radio-button__inner
  color: #fff
  background-color: #20a0ff
  border-color: #20a0ff
  box-shadow: -1px 0 0 0 #20a0ff
  opacity: .5
</style>

<template lang="pug">
.wrapper
  headers(:navNum="navNum", :username = "username")
  .layout-wrapper
    layout
      template(slot="page")
        h2 应用创建
        el-row(:gutter="20", style="margin-top:30px")
          el-col(:span="12")
            el-form(:model="appForm", ref="appForm", :rules="rules", label-width="100px")
              el-form-item(label="应用名称", prop="appName")
                el-input(v-model="appForm.appName", placeholder="不超过20个字符")
              el-form-item(label="应用分类", prop="appType")
                el-radio-group.radio-group(v-model="appForm.appType")
                  el-radio(label='1') 游戏
                  el-radio(label='2') 应用
              el-form-item(label="应用图片", prop="appPicture")
                el-upload.avatar-uploader(
                  class="avatar-uploader"
                  ref="selectImg"
                  action="https://v0.api.upyun.com/one-click-login"
                  :data="imgParams"
                  accept="image/jpg,image/png"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="onBeforeUpload")
                  img.avatar(v-if="imageUrl", :src="imageUrl")
                  i.el-icon-plus(v-else, :src="imageUrl", class="avatar-uploader-icon")
              p.list-group.content-description 请上传应用图片，支持 jpg、png 格式，且不超过3M。
              el-form-item(label="应用介绍", prop="appIntroduction")
                el-input(type="textarea", v-model="appForm.appIntroduction", :rows="5", placeholder="不超过200个字符")
              el-form-item(label="应用平台", prop="appPlatform")
                el-checkbox-group.radio-group(v-model="appForm.appPlatform")
                  el-checkbox-button(label="ios", key="ios") IOS 平台
                  el-checkbox-button(label="android", key="android") Android 平台
              el-form-item.platform-item(label="Bundle ID", prop="BundleId", v-if="appForm.appPlatform.indexOf('ios') !== -1")
                el-input(v-model="appForm.BundleId", placeholder="请输入 Bundle ID")
                el-tooltip(effect="dark", content="IOS 应用的唯一标识。例:com.upyun.app", placement="right")
                  i.el-icon-information
              el-form-item.platform-item(label="应用签名", prop="androidSignature", v-if="appForm.appPlatform.indexOf('android') !== -1")
                el-input(v-model="appForm.androidSignature", placeholder="请输入应用签名")
                el-tooltip(effect="dark", content="格式: 32 位数（仅支持数字+小写英文）。", placement="right")
                  i.el-icon-information
              el-form-item.platform-item(label="应用包名", prop="androidPackageName", v-if="appForm.appPlatform.indexOf('android') !== -1")
                el-input(v-model="appForm.androidPackageName", placeholder="请输入应用包名")
                el-tooltip(effect="dark", content="例: com.upyun.app", placement="right")
                  i.el-icon-information
              el-form-item(label="RSA 公钥", prop="RSAPublicKey")
                el-input(v-model="appForm.RSAPublicKey", placeholder="请输入 RSA 公钥")
                el-tooltip(effect="dark", content="1024bit pkcs#8格式，用于访问接口验签。", placement="right")
                  i.el-icon-information
        .footer
          .submit-groups
            sms_button.submit-btn(@click.native="goBack") 取消
            sms_button.submit-btn(@click.native="createApp", type="major") 提交
</template>

<script>
import headers from '../components/headers'
import layout from '../components/layout'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import $http from '../api/http'

export default {
  components: { headers, layout },
  data () {
    const checkSign = (rule, value, callback) => {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{32}$/;
      if (!reg.test(value)) {
        callback(new Error('请输入正确格式的应用签名'));
      } else callback();
    };
    return {
      imageUrl: '',
      navNum: 3,
      imgParams: {
        authorization: '',
        policy: ''
      },
      rules: {
        appName: [
          { required: true, message: '请填写应用名称', trigger: 'blur' },
          { max: 20, message: '长度不能超过 20 个字符', trigger: 'blur' }
        ],
        appType: [
          { required: true, message: '请选择应用类型', trigger: 'change' }
        ],
        appPlatform: [
          { type: 'array', required: true, message: '请选择应用平台', trigger: 'change' }
        ],
        appIntroduction: [
          { required: true, message: '请填写应用介绍', trigger: 'blur' },
          { min: 30, message: '长度不能少于 30 个字符', trigger: 'blur' },
          { max: 200, message: '长度不能超过 200 个字符', trigger: 'blur' }
        ],
        BundleId: [
          { required: true, message: '请填写 Bundle ID', trigger: 'blur' }
        ],
        androidSignature: [
          { required: true, message: '请填写应用签名', trigger: 'blur' },
          { validator: checkSign, trigger: 'blur' }
        ],
        androidPackageName: [
          { required: true, message: '请填写应用包名', trigger: 'blur' }
        ],
        RSAPublicKey: [
          { required: true, message: '请填写 RSA 公钥', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      signatures: state => state.createApplication.signatures,
      isEdit: state => state.createApplication.isEdit,
      id: state => state.createApplication.id,
      lastSignatureId: state => state.createApplication.lastSignatureId,
      username: state => state.dashboard.username
    }),
    appForm: {
      get: function () {
        const vm = this;
        return {
          get appPlatform () {
            return vm.$store.state.createApplication.appPlatform;
          },
          set appPlatform (value) {
            vm.$store.commit({
              type: 'UPDATE_APP_PLATFORM',
              value
            });
          },
          get appType () {
            return vm.$store.state.createApplication.appType;
          },
          set appType (value) {
            vm.$store.commit({
              type: 'UPDATE_APP_TYPE',
              value
            });
          },
          get appName () {
            return vm.$store.state.createApplication.appName;
          },
          set appName (value) {
            vm.$store.commit({
              type: 'UPDATE_APP_NAME',
              value
            });
          },
          get appIntroduction () {
            return vm.$store.state.createApplication.appIntroduction;
          },
          set appIntroduction (value) {
            vm.$store.commit({
              type: 'UPDATE_INTRODUCTION',
              value
            });
          },
          get BundleId () {
            return vm.$store.state.createApplication.BundleId;
          },
          set BundleId (value) {
            vm.$store.commit({
              type: 'UPDATE_BUNDLEID',
              value
            });
          },
          get androidSignature () {
            return vm.$store.state.createApplication.androidSignature;
          },
          set androidSignature (value) {
            vm.$store.commit({
              type: 'UPDATE_SIGN_NAME',
              value
            });
          },
          get androidPackageName () {
            return vm.$store.state.createApplication.androidPackageName;
          },
          set androidPackageName (value) {
            vm.$store.commit({
              type: 'UPDATE_PACKAGE_NAME',
              value
            });
          },
          get RSAPublicKey () {
            return vm.$store.state.createApplication.RSAPublicKey;
          },
          set RSAPublicKey (value) {
            vm.$store.commit({
              type: 'UPDATE_RSA_KEY',
              value
            });
          }
        };
      }
    }
  },
  mounted () {
    this.$store.commit('INIT_APPFORM');
  },
  methods: {
    onBeforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt3M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG、PNG 格式!');
        return false;
      }
      if (!isLt3M) {
        this.$message.error('上传头像图片大小不能超过 3MB!');
        return false;
      }
      const params = {
        uri: '/one-click-login',
        save_key: '/' + file.name,
        expiration: Date.parse(new Date()) / 1000 + 30 * 60,
        date: new Date(),
        bucket: 'one-click-login'
      }
      return $http('/authenticate', {
        method: 'GET',
        params: { ...params }
      }).then(res => {
        const { policy, Authorization } = res.data
        this.imgParams.authorization = Authorization
        this.imgParams.policy = policy
      })
    },
    handleAvatarSuccess (res, file) {
      this.appForm.appPicture = file.name
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getZhugeString (list = []) {
      if (!Array.isArray(list)) list = [];
      const addString = list.reduce((calc, current) => {
        return calc + current + '&';
      }, '');
      return addString.substr(0, addString.length - 1);
    },
    goBack () {
      zhuge.track('一键登录创建应用 - 取消', {
        账号: this.username,
        应用平台: this.getZhugeString(this.appForm.appPlatform),
        应用分类: this.appForm.appType === '1' ? '游戏' : '应用'
      });
      this.$router.push('/application');
    },
    createApp () {
      this.$refs.appForm.validate((valid) => {
        if (valid) {
          // 创建应用
          this.$store.dispatch('createApplication', this.appForm).then(resolve => {
            if (resolve.result) {
              zhuge.track('一键登录创建应用 - 提交成功', {
                账号: this.username,
                应用平台: this.getZhugeString(this.appForm.appPlatform),
                应用分类: this.appForm.appType === '1' ? '游戏' : '应用'
              });
              Message.success('应用创建成功！');
              this.$router.push('/application');
              return;
            }

            let failedReason = resolve.message || '未知错误';
            Message.error(failedReason);
            zhuge.track('一键登录创建应用 - 提交失败', {
              账号: this.username,
              应用平台: this.getZhugeString(this.appForm.appPlatform),
              应用分类: this.appForm.appType === '1' ? '游戏' : '应用',
              失败原因: failedReason
            });
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// createApplication.vue?774d78ac